import { useState } from "react";

import { Box, Slider, Typography } from "@mui/material";

export default function ExpirationSlider({ meta, setMeta }) {
  const [value, setValue] = useState(6);

  const expiresInOptions = [
    { label: "24hr", value: 1 },
    { label: "1wk", value: 2 },
    { label: "1m", value: 3 },
    { label: "3m", value: 4 },
    { label: "6m", value: 5 },
    { label: "Never", value: 6 },
  ];

  function valuetext() {
    const option = expiresInOptions.find((option) => option.value === value);
    return option ? option.label : "";
  }

  const optionsSecondsMap = {
    1: 86400, // 24 hours
    2: 604800, // 7 days
    3: 2592000, // 1 month
    4: 7776000, // 3 months
    5: 15552000, // 6 months
    6: 315360000, // 10 years
  };

  const handleExpiresChange = (event, newValue) => {
    setValue(newValue);
    setMeta({ ...meta, expiresIn: optionsSecondsMap[newValue] });
  };

  return (
    <Box sx={{ p: 1, opacity: 0.6 }}>
      <Box style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="body1">Expires:</Typography>
        <Typography variant="body1">{valuetext()}</Typography>
      </Box>
      <Slider
        aria-label="Expires in"
        value={value}
        onChange={handleExpiresChange}
        step={null}
        min={0.8}
        max={6.2}
        valueLabelDisplay="off"
        marks={expiresInOptions}
        sx={{ color: "white" }}
      />
    </Box>
  );
}
